/** 数値の0埋め。時刻表示で使う。 */
export const pad = (n: number): string => String(n).padStart(2, '0');

/**
 * 時刻は必ず「12時24分」と書く。
 * 経過時間の「24分」と取り違えないための約束で、確定済み画面と同じ規則。
 */
export const fmt = (ts: number): string => {
  const d = new Date(ts);
  return `${d.getHours()}時${pad(d.getMinutes())}分`;
};

/** 大きく見せる時刻の分解。数字を主役に、「時・分」はひと回り小さく出す。 */
export const fmtBigParts = (ts: number): { h: number; m: string } => {
  const d = new Date(ts);
  return { h: d.getHours(), m: pad(d.getMinutes()) };
};

export const minutesSince = (ts: number, now: number): number =>
  Math.max(0, Math.floor((now - ts) / 60000));

export const todayLabel = (now: number): string => {
  const d = new Date(now);
  return `${d.getMonth() + 1}月${d.getDate()}日（${'日月火水木金土'[d.getDay()]}）`;
};

export const ymd = (now: number): string => {
  const d = new Date(now);
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}`;
};

/** 同姓（姓が同じ）の判定。取り違え防止の注意喚起に使う（要件 #14）。 */
export const surname = (name: string): string => String(name).split(/[\s　]/)[0] ?? '';
